module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue3_m.0598b19d0306976ee90e6165f2f549af.png";